import React, { useState } from 'react'

import PropTypes from 'prop-types';
import {Link as RouterLink, useHistory} from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, IconButton, Hidden, Badge } from '@material-ui/core';

import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';

const useStyles = makeStyles(theme => ({
    flexGrow: {
        flexGrow: 1
    },
    menu:{
        marginLeft: theme.spacing(2)
    },
    logoImg:{
        height: 45
    }
}))

function Header(props) {
    const { className, sideBarHandler, sideBarStatus, ...rest } = props;
    const classes = useStyles()
    const history= useHistory()

    const [notifications, setNotifications]= useState(4)
    return (
        // <div

        // >
        //     Header
        // </div>

        <AppBar position="fixed">
            <Toolbar>
                {/* <Hidden >

                </Hidden> */}

                <RouterLink to="/">
                    <img 
                    src="/images/logos/drakto-5.svg" 
                    alt="Logo" 
                    className={classes.logoImg} />
                </RouterLink>
                
                <IconButton edge="start" color="inherit" 
                className={classes.menu}
                onClick={sideBarHandler}>
                    {
                        sideBarStatus? <KeyboardArrowLeftIcon /> : <MenuIcon />
                    }
                </IconButton>

                <div className={classes.flexGrow}></div>
                <Hidden smDown>
                    <IconButton color="inherit">
                    <Badge badgeContent={notifications} color="primary" >
                        <NotificationsIcon />
                    </Badge>
                    </IconButton>
                </Hidden>
                <IconButton color="inherit" onClick={()=>history.push('/signin')}>
                    <ExitToAppIcon />
                </IconButton>
                {/* <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                    <MenuIcon />
                </IconButton> */}
               
               
            </Toolbar>
        </AppBar>
    )
}

export default Header
Header.propTypes={
    className: PropTypes.string,
    sideBarHandler: PropTypes.func.isRequired,
    sideBarStatus: PropTypes.bool.isRequired
}